import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogUERBaseCostEstimateBasisRowsGql } from '../catalogUerBaseCostQueries';

const requestId = 'catalogUERBaseCostEstimateBasisRows';

interface IUseCatalogUERBaseCostEstimateBasisRows {
    catalogUniqueId?: string;
    uerBaseCostId?: number;
    withEffect?: boolean;
}

export const useCatalogUERBaseCostEstimateBasisRows = (props: IUseCatalogUERBaseCostEstimateBasisRows) => {
    const { catalogUniqueId, uerBaseCostId, withEffect } = props;

    const variables = useMemo(
        () => (catalogUniqueId && uerBaseCostId ? { catalogUniqueId, uerBaseCostId } : undefined),
        [catalogUniqueId, uerBaseCostId],
    );

    const [catalogUERBaseCostEstimateBasisRowsReset] = useResetStoreData({ requestId });

    const [catalogUERBaseCostEstimateBasisRowsData, catalogUERBaseCostEstimateBasisRowsStatus] = useRequest({
        requestId,
        query: catalogUERBaseCostEstimateBasisRowsGql,
        variables,
        withEffect: !!variables && withEffect,
    });

    useEffect(() => {
        catalogUERBaseCostEstimateBasisRowsReset(undefined);
    }, [catalogUERBaseCostEstimateBasisRowsReset]);

    const items = useMemo(
        () => catalogUERBaseCostEstimateBasisRowsData?.catalogUERBaseCostEstimateBasisRows || [],
        [catalogUERBaseCostEstimateBasisRowsData?.catalogUERBaseCostEstimateBasisRows],
    );

    return {
        status: catalogUERBaseCostEstimateBasisRowsStatus,
        items,
    };
};
